export default __webpack_public_path__ + "static/media/FeriaFlores.481bcac0.jpg";